import React, { useState } from "react";
import { motion } from "framer-motion";

interface Tab {
    id: string;
    title: string;
    icon: React.ReactNode;
    color: string;
}

interface SensorTabsProps {
    tabs: Tab[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
    isRTL: boolean;
}

const SensorTabs: React.FC<SensorTabsProps> = ({ tabs, activeTab, onTabChange, isRTL }) => {
    const [isHovering, setIsHovering] = useState<string | null>(null);

    return (
        <div className="relative w-full md:w-10/12 mx-auto px-6  ">
            {/* Horizontal scroll container */}
            <div className="overflow-x-auto py-4 hide-scrollbar">
                <div className="flex gap-5 min-w-max px-2">
                    {tabs.map((tab) => (
                        <motion.button
                            key={tab.id}
                            className={`relative px-4 py-2.5 rounded-xl text-sm font-medium flex items-center backdrop-blur-sm ${
                                activeTab === tab.id ? "text-white shadow-lg" : "bg-white/40 text-gray-700 hover:bg-white/60 border border-gray-100"
                            }`}
                            onClick={() => onTabChange(tab.id)}
                            onMouseEnter={() => setIsHovering(tab.id)}
                            onMouseLeave={() => setIsHovering(null)}
                            whileHover={{ scale: 1.05, y: -2 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            {activeTab === tab.id && (
                                <motion.div
                                    className={`absolute inset-0 bg-gradient-to-r ${tab.color} rounded-xl -z-10`}
                                    layoutId="activeTab"
                                    initial={false}
                                    transition={{ type: "spring", duration: 0.5 }}
                                />
                            )}

                            <motion.span
                                className={`me-2 text-lg`}
                                animate={{
                                    scale: isHovering === tab.id || activeTab === tab.id ? 1.2 : 1,
                                    rotate: isHovering === tab.id ? [0, -10, 10, -5, 5, 0] : 0,
                                }}
                                transition={{ duration: 0.5 }}
                            >
                                {tab.icon}
                            </motion.span>
                            {tab.title}
                        </motion.button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SensorTabs;
